export default __webpack_public_path__ + "static/media/completed_group.16044c81.svg";